import { notifySessionChanged } from './sessionEvents';
import { requestJson } from './requestJson';
const API = `${process.env.REACT_APP_BACKEND_URL.replace(/\/+$/, '')}/api`;

const post = (path, body) => requestJson(`${API}${path}`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) }, {timeoutMs: 20000, label: 'Sign-in'})
  .then((d) => {
    if(path.startsWith('/auth/'))notifySessionChanged();
    return d;
  });

export const authApi = {
  me: (signal) => requestJson(`${API}/auth/me`, {cache:'no-store', signal}, {label: 'Session check'}),
  team: (passcode, workspace) => post("/auth/team", { passcode, workspace }),
  presenter: (passcode, workspace) => post('/auth/presenter', {passcode,workspace}),
  viewer: (code, passcode) => post("/auth/viewer", { code, passcode }),
  share: (raceId, raceName, workspace = "racing") => post("/share", { race_id: raceId, race_name: raceName, workspace }),
  shares: (workspace = "racing") => fetch(`${API}/share?workspace=${workspace}`).then((r) => r.json()),
  revoke: (code) => post(`/share/${encodeURIComponent(code)}/revoke`, {}),
  shareInfo: (code) => requestJson(`${API}/share/${encodeURIComponent(code)}`, {cache:'no-store'}, {label:'Access link', retries:1}),
};
